import { MicErrorKind } from "@/lib/sip";
import { faCircleExclamation } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FC } from "react";

const MESSAGES: Record<MicErrorKind, string> = {
  micNoDevice: "Aucun micro détecté. Branchez un micro puis réessayez.",
  micDenied:
    "L'accès au micro a été refusé. Autorisez-le dans les paramètres de votre navigateur.",
  micInUse: "Le micro est déjà utilisé par une autre application.",
};

const WebphoneMicError: FC<{ kind: MicErrorKind }> = ({ kind }) => (
  <div className="px-3 pb-2">
    <div className="d-flex align-items-start gap-2 bg-danger-subtle text-danger-emphasis rounded-2 p-2 fs--1">
      <FontAwesomeIcon icon={faCircleExclamation} className="mt-1 flex-shrink-0" />
      <span>{MESSAGES[kind]}</span>
    </div>
  </div>
);

export default WebphoneMicError;
